var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.drugs, function (drug, index) {
        return _c("div", { key: index, staticClass: "flex mb-1" }, [
          _c(
            "div",
            { staticClass: "selectDrugBlock" },
            [
              _c("DrugSearchNew", {
                ref: "selectedDrug",
                refInFor: true,
                attrs: {
                  searchOptions: { prices: true },
                  onSelect: _vm.selectDrug,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: drug.qty,
                  expression: "drug.qty",
                },
              ],
              staticClass: "form-control",
              attrs: { type: "number" },
              domProps: { value: drug.qty },
              on: {
                change: _vm.updateDrugs,
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(drug, "qty", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: drug.price,
                  expression: "drug.price",
                },
              ],
              staticClass: "form-control",
              attrs: { disabled: "", type: "text" },
              domProps: { value: drug.price },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(drug, "price", $event.target.value)
                },
              },
            }),
          ]),
        ])
      }),
      _vm._v(" "),
      _c("div", [
        _c(
          "button",
          {
            staticClass: "btn-xs btn btn-info m-t-10",
            on: { click: _vm.addNewDrug },
          },
          [_vm._v("Добавить препарат")]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }